import { fromLocationsDTO } from "./location"

export const fromInstituteDTO = ({
    name,
    locations,
    allowFlexTimeAccountsDefault,
    allowAdditionalCompensationForClosingDays,
    maxFlexTimeCredit,
    maxFlexTimeDeficit,
}) => {
    return {
        name,
        locations: fromLocationsDTO(locations),
        allowFlexTimeAccountsDefault,
        allowAdditionalCompensationForClosingDays,
        maxFlexTimeCredit,
        maxFlexTimeDeficit,
    }
}

export const fromInstitutesDTO = (institutes) => institutes.map(i => fromInstituteDTO(i))

export const toInstituteDTO = (institute) => {
    return {
        name: institute.name,
        allowFlexTimeAccountsDefault : institute.allowFlexTimeAccountsDefault,
        maxFlexTimeCredit: institute.maxFlexTimeCredit,
        maxFlexTimeDeficit: institute.maxFlexTimeDeficit,
        allowAdditionalCompensationForClosingDays: institute.allowAdditionalCompensationForClosingDays
    }
}